import { Grid } from "@material-ui/core";
import React, { useEffect, useState } from "react";

export default function HeaderBackground() {
	const [bg, setBg] = useState(false);

	useEffect(() => {
		window.addEventListener("scroll", (e) => {
			if (window.innerWidth < 960) {
				if (window.pageYOffset > 100) {
					setBg(true);
				} else if (window.pageYOffset < 100) {
					setBg(false);
				}
			}
		});
	}, []);

	return (
		<Grid
			container
			style={{
				backgroundColor: "transparent",
				backgroundImage: bg
					? "linear-gradient(to right,rgb(52 145 184), rgb(32 217 205))"
					: null,
				height: 80,
				position: "fixed",
				top: 0,
				transition: "all 0.3s linear",
				zIndex:20
			}}
		></Grid>
	);
}
